import {useGetAndSet} from "./useGetAndSet";
import {createSetContactsDataAction} from "../actions/dataActions";


export const useWorkshopsData = (params, dataFresh) => {
    return useGetAndSet("workshops", params, createSetContactsDataAction, dataFresh);
}